"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PARTNERS_ROLES = void 0;
var PARTNERS_ROLES;
(function (PARTNERS_ROLES) {
    PARTNERS_ROLES["SEARCH_PARTNERS"] = "search-partners";
    PARTNERS_ROLES["VIEW_PARTNER"] = "view-partner";
    PARTNERS_ROLES["CREATE_PARTNER"] = "create-partner";
    PARTNERS_ROLES["MODIFY_PARTNER"] = "modify-partner";
    PARTNERS_ROLES["DELETE_PARTNER"] = "delete-partner";
    PARTNERS_ROLES["CREATE_PARTNER_ADDRESS"] = "create-partner-address";
    PARTNERS_ROLES["MODIFY_PARTNER_ADDRESS"] = "modify-partner-address";
    PARTNERS_ROLES["DELETE_PARTNER_ADDRESS"] = "delete-partner-address";
    PARTNERS_ROLES["APPROVE_PARTNER_ADDRESS"] = "approve-partner-address";
    PARTNERS_ROLES["CREATE_PARTNER_CONTACT"] = "create-partner-contact";
    PARTNERS_ROLES["MODIFY_PARTNER_CONTACT"] = "modify-partner-contact";
    PARTNERS_ROLES["DELETE_PARTNER_CONTACT"] = "delete-partner-contact";
    PARTNERS_ROLES["APPROVE_PARTNER_CUSTOMER"] = "approve-partner-customer";
    PARTNERS_ROLES["APPROVE_PARTNER_VENDOR"] = "approve-partner-vendor";
})(PARTNERS_ROLES = exports.PARTNERS_ROLES || (exports.PARTNERS_ROLES = {}));
//# sourceMappingURL=partners.roles.js.map